import { defineMessages } from "react-intl";

/** Fixed UI strings of the Featured Product Slider. */
const messages = defineMessages({
  logoLinkFallback: {
    id: "featuredProductSlider.logo_link_fallback",
    defaultMessage: "Shop the collection",
  },
});

export default messages;
